export const environment = {
  production: false,
  url: 'https://api.dev.amsyst.com/'
};